<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<path class="color-vector" d="M5.83,21.71h1.66c0.75,0,1.47-0.3,2-0.83l11.4-11.4c0.53-0.53,0.83-1.25,0.83-2V5.83L5.83,21.71z" />
	<polygon class="color-solid" points="20.29,2.29 2.29,20.29 3.71,21.71 21.71,3.71" />
</svg>
</template>